<template>
  <div class="solution-info" v-show="!loading">
    <!-- Banner -->
    <div class="banner">
      <img :src="preloadedImages.png09" alt="Company Profile" class="banner-img" v-if="preloadedImages.png09">
      <div class="overlay"></div>
      <div class="banner-text">
        <h1>{{ $t('solutions') }}</h1>
        <h3>{{ $t('solutions1') }}</h3>
      </div>
    </div>

    <!-- SES Section -->
    <div id="SES" class="section ses" v-observe-visibility="onVisibilityChange">
      <div class="ses-content">
        <div class="vision-header">
        <h2>{{ $t('solutionInfo.ses.title') }}</h2>
        </div>
        <div class="vision-content">
        <p><strong>{{ $t('solutionInfo.overview') }}</strong><br>{{ $t('solutionInfo.ses.description') }}<br>{{ $t('solutionInfo.ses.description1') }}</p>
        <p>
          <strong>{{ $t('solutionInfo.technicalFields') }}</strong><br>
          <ul class="fields">
            <li class="field">
              <span class="field-label">{{ $t('solutionInfo.ses.frontend') }}：</span>
              <span class="field-content">{{ $t('solutionInfo.ses.frontendContent') }}</span>
            </li>
            <li class="field">
              <span class="field-label">{{ $t('solutionInfo.ses.languages') }}：</span>
              <span class="field-content">{{ $t('solutionInfo.ses.languagesContent') }}</span>
            </li>
            <li class="field">
              <span class="field-label">{{ $t('solutionInfo.ses.database') }}：</span>
              <span class="field-content">{{ $t('solutionInfo.ses.databaseContent') }}</span>
            </li>
          </ul>
        </p>
        </div>
      <img :src="preloadedImages.png10" alt="Company Profile" class="img" v-if="preloadedImages.png10">
      </div>
    </div>

    <!-- App Development Section -->
    <div id="AppDev" class="section app-dev" v-observe-visibility="onVisibilityChange">
      <div class="app-dev-content">
        <div class="vision-header">
        <h2>{{ $t('solutionInfo.appDev.title') }}</h2>
        </div>
        <div class="vision-content">
        <p><strong>{{ $t('solutionInfo.overview') }}</strong><br>{{ $t('solutionInfo.appDev.description') }}</p>
        <p><strong>{{ $t('solutionInfo.services') }}</strong><br>{{ $t('solutionInfo.appDev.services') }}</p>
        </div>
      <img :src="preloadedImages.png11" alt="Company Profile" class="img" v-if="preloadedImages.png11">
      </div>
    </div>

    <!-- Skill Section -->
    <div id="Skill" class="section skill" v-observe-visibility="onVisibilityChange">
      <div class="ses-content">
        <div class="vision-header">
        <h2>{{ $t('solutionInfo.skill.title') }}</h2>
        </div>
        <div class="vision-content">
        <p><strong>{{ $t('solutionInfo.overview') }}</strong><br>{{ $t('solutionInfo.skill.description') }}<br>{{ $t('solutionInfo.skill.description1') }}<br>{{ $t('solutionInfo.skill.description2') }}</p>
        <p>
          <strong>{{ $t('solutionInfo.technicalFields') }}</strong><br>
          <ul class="fields">
            <li class="field">
              <span class="field-label">{{ $t('solutionInfo.skill.environment') }}：</span>
              <span class="field-content">{{ $t('solutionInfo.skill.environmentContent') }}</span>
            </li>
            <li class="field">
              <span class="field-label">{{ $t('solutionInfo.skill.languages') }}：</span>
              <span class="field-content">{{ $t('solutionInfo.skill.languagesContent') }}</span>
            </li>
            <li class="field">
              <span class="field-label">{{ $t('solutionInfo.skill.database') }}：</span>
              <span class="field-content">{{ $t('solutionInfo.skill.databaseContent') }}</span>
            </li>
          </ul>
        </p>
        </div>
      <img :src="preloadedImages.png12" alt="Company Profile" class="img" v-if="preloadedImages.png12">
      </div>
    </div>

    <!-- Develop Section -->
    <div id="Develop" class="section develop" v-observe-visibility="onVisibilityChange">
      <div class="vision-header">
      <h2>{{ $t('solutionInfo.develop.title') }}</h2>
      </div>
      <table class="company-table">
        <tr>
          <td class="first-child" v-html="$t('solutionInfo.develop.Webtitle')"></td>
          <td v-html="`${$t('solutionInfo.develop.WebNameLabel1')}<br><br>${$t('solutionInfo.develop.WebNameLabel2')}<br><br>${$t('solutionInfo.develop.WebNameLabel3')}<br><br>${$t('solutionInfo.develop.WebNameLabel4')}
            <br><br>${$t('solutionInfo.develop.WebNameLabel5')}<br><br>${$t('solutionInfo.develop.WebNameLabel6')}<br><br>${$t('solutionInfo.develop.WebNameLabel7')}`"></td>
        </tr>
        <tr>
          <td class="first-child" v-html="$t('solutionInfo.develop.apptitle')"></td>
          <td v-html="`${$t('solutionInfo.develop.appNameLabel1')}<br><br>${$t('solutionInfo.develop.appNameLabel2')}`"></td>
        </tr>
        <tr>
          <td class="first-child" v-html="$t('solutionInfo.develop.packagetitle')"></td>
          <td v-html="`${$t('solutionInfo.develop.packageNameLabel1')}<br><br>${$t('solutionInfo.develop.packageNameLabel2')}`"></td>
        </tr>
      </table>
      <img :src="preloadedImages.png13" alt="Company Profile" class="img" v-if="preloadedImages.png13">
    </div>

    <!-- Dispatch Services Section -->
    <!-- <div id="Dispatch" class="section dispatch" v-observe-visibility="onVisibilityChange">
      <div class="dispatch-content">
        <div class="vision-header">
        　<h2>{{ $t('solutionInfo.dispatch.title') }}</h2>
        </div>
        <div class="vision-content">
        　<p><strong>{{ $t('solutionInfo.overview') }}</strong><br>{{ $t('solutionInfo.dispatch.description') }}</p>
        　<p><strong>{{ $t('solutionInfo.services') }}</strong><br>{{ $t('solutionInfo.dispatch.services') }}</p>
        <img :src="preloadedImages.png10" alt="Company Profile" class="img" v-if="preloadedImages.png10">
        </div>
      </div>
    </div> -->

    <!-- T2solution Section -->
    <div id="T2solution" class="section t2solution" v-observe-visibility="onVisibilityChange">
      <div class="app-dev-content">
        <div class="vision-header">
        <h2>{{ $t('solutionInfo.t2solution.title') }}</h2>
        </div>
        <div class="vision-content">
        <p><strong>{{ $t('solutionInfo.t2solution.work01') }}</strong><br><span v-html="$t('solutionInfo.t2solution.description01')"></span></p>
        <p><strong>{{ $t('solutionInfo.t2solution.work02') }}</strong><br><span v-html="$t('solutionInfo.t2solution.description02')"></span></p>
        <p><strong>{{ $t('solutionInfo.t2solution.work03') }}</strong><br><span v-html="$t('solutionInfo.t2solution.description03')"></span></p>
        <p><strong>{{ $t('solutionInfo.t2solution.work04') }}</strong><br><span v-html="$t('solutionInfo.t2solution.description04')"></span></p>
        </div>
      <img :src="preloadedImages.png04" alt="Company Profile" class="img" v-if="preloadedImages.png04">
      </div>
    </div>

    <!-- T1solution Section -->
    <div id="Work0" class="section t1solution" v-observe-visibility="onVisibilityChange">
      <div class="app-dev-content">
        <div class="vision-header">
        <h2>{{ $t('solutionInfo.t1solution.title') }}</h2>
        </div>
        <div class="vision-content1">
        <p><strong>{{ $t('solutionInfo.t1solution.work0') }}</strong><br>
        <br><strong>{{ $t('solutionInfo.t1solution.work001') }}</strong></span>
        <br><span v-html="$t('solutionInfo.t1solution.description001')"></span><br>
        <br><strong>{{ $t('solutionInfo.t1solution.work002') }}</strong></span>
        <br><span v-html="$t('solutionInfo.t1solution.description002')"></span></p>
        </div>
        <img :src="preloadedImages.png10" alt="Company Profile" class="img" v-if="preloadedImages.png10">
      </div>
    </div>
    <!-- Work1 Section -->
    <div id="Work1" class="section work1" v-observe-visibility="onVisibilityChange">
      <div class="app-dev-content">
        <div class="vision-content1">
          <p><strong>{{ $t('solutionInfo.t1solution.work1') }}</strong><br>
          <br><span v-html="$t('solutionInfo.t1solution.description1a')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description1b')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description1c')"></span></p>
        </div>
      </div>
    </div>
    <!-- Work2 Section -->
    <div id="Work2" class="section work2" v-observe-visibility="onVisibilityChange">
      <div class="app-dev-content">
        <div class="vision-content1">
          <p><strong>{{ $t('solutionInfo.t1solution.work2') }}</strong><br>
          <br><span v-html="$t('solutionInfo.t1solution.description2a')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description2b')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description2c')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description2d')"></span>
          <ul>
            <li>
              <a href="https://www.mhlw.go.jp/stf/newpage_09221.html" class="others-link" target="_blank" rel="noopener noreferrer">
                 https://www.mhlw.go.jp/stf/newpage_09221.html
              </a>
            </li>
          </ul>
          </p>
        </div>
      </div>
    </div>
    <!-- Work3 Section -->
    <div id="Work3" class="section work3" v-observe-visibility="onVisibilityChange">
      <div class="app-dev-content">
        <div class="vision-content1">
          <p><strong>{{ $t('solutionInfo.t1solution.work3') }}</strong><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description3a') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description3aa')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description3ab')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description3ac')"></span><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description3b') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description3ba')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description3bb')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description3bc')"></span><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description3c') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description3ca')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description3cb')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description3cc')"></span><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description3d') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description3da')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description3db')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description3dc')"></span><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description3e') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description3ea')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description3eb')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description3ec')"></span><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description3f') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description3fa')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description3fb')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description3fc')"></span><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description3g') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description3ga')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description3gb')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description3gc')"></span><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description3h') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description3ha')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description3hb')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description3hc')"></span><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description3i') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description3ia')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description3ib')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description3ic')"></span><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description3j') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description3ja')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description3jb')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description3jc')"></span></p>
        </div>
      </div>
    </div>
    <!-- Work4 Section -->
    <div id="Work4" class="section work4" v-observe-visibility="onVisibilityChange">
      <div class="app-dev-content">
        <div class="vision-content1">
          <p><strong>{{ $t('solutionInfo.t1solution.work4') }}</strong><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description4a') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description4aa')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description4ab')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description4ac')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description4ad')"></span>
          <ul>
            <li>
              <a href="https://www.mlit.go.jp/tochi_fudousan_kensetsugyo/tochi_fudousan_kensetsugyo_tk3_000001_00003.html" class="others-link" target="_blank" rel="noopener noreferrer">
                 https://www.mlit.go.jp/tochi_fudousan_kensetsugyo/tochi_fudousan_kensetsugyo_tk3_000001_00003.html
              </a>
            </li>
          </ul><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description4b') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description4ba')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description4bb')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description4bc')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description4bd')"></span>
          <ul>
            <li>
              <a href="https://www.mlit.go.jp/tochi_fudousan_kensetsugyo/tochi_fudousan_kensetsugyo_tk3_000001_00003.html" class="others-link" target="_blank" rel="noopener noreferrer">
                 https://www.mlit.go.jp/tochi_fudousan_kensetsugyo/tochi_fudousan_kensetsugyo_tk3_000001_00003.html
              </a>
            </li>
          </ul><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description4c') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description4ca')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description4cb')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description4cc')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description4cd')"></span>
          <ul>
            <li>
              <a href="https://www.mlit.go.jp/tochi_fudousan_kensetsugyo/tochi_fudousan_kensetsugyo_tk3_000001_00003.html" class="others-link" target="_blank" rel="noopener noreferrer">
                 https://www.mlit.go.jp/tochi_fudousan_kensetsugyo/tochi_fudousan_kensetsugyo_tk3_000001_00003.html
              </a>
            </li>
          </ul>
          </p>
        </div>
      </div>
    </div>
    <!-- Work5 Section -->
    <div id="Work5" class="section work5" v-observe-visibility="onVisibilityChange">
      <div class="app-dev-content">
        <div class="vision-content1">
          <p><strong>{{ $t('solutionInfo.t1solution.work5') }}</strong><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description5a') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description5aa')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description5ab')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description5ac')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description5ad')"></span>
          <ul>
            <li>
              <a href="https://www.mlit.go.jp/maritime/maritime_fr5_000006.html" class="others-link" target="_blank" rel="noopener noreferrer">
                 https://www.mlit.go.jp/maritime/maritime_fr5_000006.html
              </a>
            </li>
          </ul><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description5b') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description5ba')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description5bb')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description5bc')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description5bd')"></span>
          <ul>
            <li>
              <a href="https://www.mlit.go.jp/maritime/maritime_fr5_000006.html" class="others-link" target="_blank" rel="noopener noreferrer">
                 https://www.mlit.go.jp/maritime/maritime_fr5_000006.html
              </a>
            </li>
          </ul><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description5c') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description5ca')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description5cb')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description5cc')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description5cd')"></span>
          <ul>
            <li>
              <a href="https://www.mlit.go.jp/maritime/maritime_fr5_000006.html" class="others-link" target="_blank" rel="noopener noreferrer">
                 https://www.mlit.go.jp/maritime/maritime_fr5_000006.html
              </a>
            </li>
          </ul>
          </p>
        </div>
      </div>
    </div>
    <!-- Work6 Section -->
    <div id="Work6" class="section work6" v-observe-visibility="onVisibilityChange">
      <div class="app-dev-content">
        <div class="vision-content1">
          <p><strong>{{ $t('solutionInfo.t1solution.work6') }}</strong><br>
          <br><span v-html="$t('solutionInfo.t1solution.description6a')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description6b')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description6c')"></span></p>
        </div>
      </div>
    </div>
    <!-- Work7 Section -->
    <div id="Work7" class="section work7" v-observe-visibility="onVisibilityChange">
      <div class="app-dev-content">
        <div class="vision-content1">
          <p><strong>{{ $t('solutionInfo.t1solution.work7') }}</strong><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description7a') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description7aa')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description7ab')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description7ac')"></span><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description7b') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description7ba')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description7bb')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description7bc')"></span></p>
        </div>
      </div>
    </div>
    <!-- Work8 Section -->
    <div id="Work8" class="section work8" v-observe-visibility="onVisibilityChange">
      <div class="app-dev-content">
        <div class="vision-content1">
          <p><strong>{{ $t('solutionInfo.t1solution.work8') }}</strong><br>
          <br><span v-html="$t('solutionInfo.t1solution.description8a')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description8b')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description8c')"></span></p>
        </div>
      </div>
    </div>
    <!-- Work9 Section -->
    <div id="Work9" class="section work9" v-observe-visibility="onVisibilityChange">
      <div class="app-dev-content">
        <div class="vision-content1">
          <p><strong>{{ $t('solutionInfo.t1solution.work9') }}</strong><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description9a') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description9aa')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description9ab')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description9ac')"></span><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description9b') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description9ba')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description9bb')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description9bc')"></span><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description9c') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description9ca')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description9cb')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description9cc')"></span></p>
        </div>
      </div>
    </div>
    <!-- Work10 Section -->
    <div id="Work10" class="section work10" v-observe-visibility="onVisibilityChange">
      <div class="app-dev-content">
        <div class="vision-content1">
          <p><strong>{{ $t('solutionInfo.t1solution.work10') }}</strong><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description10a') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description10aa')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description10ab')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description10ac')"></span><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description10b') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description10ba')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description10bb')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description10bc')"></span><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description10c') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description10ca')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description10cb')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description10cc')"></span><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description10d') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description10da')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description10db')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description10dc')"></span><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description10e') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description10ea')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description10eb')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description10ec')"></span><br></p>
        </div>
      </div>
    </div>
    <!-- Work11 Section -->
    <div id="Work11" class="section work11" v-observe-visibility="onVisibilityChange">
      <div class="app-dev-content">
        <div class="vision-content1">
          <p><strong>{{ $t('solutionInfo.t1solution.work11') }}</strong><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description11a') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description11aa')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description11ab')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description11ac')"></span><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description11b') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description11ba')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description11bb')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description11bc')"></span></p>
        </div>
      </div>
    </div>
    <!-- Work12 Section -->
    <div id="Work12" class="section work12" v-observe-visibility="onVisibilityChange">
      <div class="app-dev-content">
        <div class="vision-content1">
          <p><strong>{{ $t('solutionInfo.t1solution.work12') }}</strong><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description12a') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description12aa')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description12ab')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description12ac')"></span><br>
          <br><strong>{{ $t('solutionInfo.t1solution.description12b') }}</strong>
          <br><span v-html="$t('solutionInfo.t1solution.description12ba')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description12bb')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description12bc')"></span></p>
        </div>
      </div>
    </div>
    <!-- Work13 Section -->
    <div id="Work13" class="section Work13" v-observe-visibility="onVisibilityChange">
      <div class="app-dev-content">
        <div class="vision-content1">
          <p><strong>{{ $t('solutionInfo.t1solution.work13') }}</strong><br>
          <br><span v-html="$t('solutionInfo.t1solution.description13a')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description13b')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description13c')"></span></p>
        </div>
      </div>
    </div>
    <!-- Work14 Section -->
    <div id="Work14" class="section work14" v-observe-visibility="onVisibilityChange">
      <div class="app-dev-content">
        <div class="vision-content1">
          <p><strong>{{ $t('solutionInfo.t1solution.work14') }}</strong><br>
          <br><span v-html="$t('solutionInfo.t1solution.description14a')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description14b')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description14c')"></span></p>
        </div>
      </div>
    </div>
    <!-- Work15 Section -->
    <div id="Work15" class="section work15" v-observe-visibility="onVisibilityChange">
      <div class="app-dev-content">
        <div class="vision-content1">
          <p><strong>{{ $t('solutionInfo.t1solution.work15') }}</strong><br>
          <br><span v-html="$t('solutionInfo.t1solution.description15a')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description15b')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description15c')"></span></p>
        </div>
      </div>
    </div>
    <!-- Work16 Section -->
    <div id="Work16" class="section work16" v-observe-visibility="onVisibilityChange">
      <div class="app-dev-content">
        <div class="vision-content1">
          <p><strong>{{ $t('solutionInfo.t1solution.work16') }}</strong><br>
          <br><span v-html="$t('solutionInfo.t1solution.description16a')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description16b')"></span>
          <br><span v-html="$t('solutionInfo.t1solution.description16c')"></span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { openDB } from 'idb';

const dbPromise = openDB('images-db', 1, {
  upgrade(db) {
    db.createObjectStore('images');
  },
});

async function loadImage(name) {
  const db = await dbPromise;
  const blob = await db.get('images', name);
  if (!blob) return null;
  return URL.createObjectURL(blob);
}

export default {
  name: 'SolutionInfo',
  data() {
    return {
      activeIcon: null,
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    preloadedImages: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    navigateToSection(sectionId) {
      location.hash = `#${sectionId}`;
    },
    onVisibilityChange(isVisible, entry) {
      if (isVisible) {
        entry.target.classList.add('visible');
        if (entry.target.id) {
          const paragraphs = entry.target.querySelectorAll('p');
          paragraphs.forEach((p, index) => {
            p.classList.remove('fade-in-visible');
            setTimeout(() => {
              p.classList.add('fade-in-visible');
            }, index * 150); // Adjust the delay time as needed
          });
        }
      } else {
        entry.target.classList.remove('visible');
        if (entry.target.id) {
          const paragraphs = entry.target.querySelectorAll('p');
          paragraphs.forEach((p) => {
            p.classList.remove('fade-in-visible');
          });
        }
      }
    },
    setActiveIcon(index) {
      this.activeIcon = index;
    }
  },
  directives: {
    'observe-visibility': {
      inserted(el, binding) {
        const options = {
          threshold: 0.1 // Adjust as needed
        };
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (binding.value && typeof binding.value === 'function') {
              binding.value(entry.isIntersecting, entry);
            }
          });
        }, options);
        observer.observe(el);
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;700&display=swap');

.links a.vision-content p {
  font-size: 20px;
  color: rgb(15, 101, 22);
  text-decoration: none;
  transition: color 0.3s ease;
}

.links a.vision-content p:hover {
  color: #3498db;
}

.solution-info {
  width: 100%;
  background: url('../assets/img/background.webp') center/cover no-repeat fixed;
  padding: 50px 0;
  text-align: center;
  font-family: 'Noto Sans JP', sans-serif;

  .banner {
    position: relative;
    width: 100%;
    height: 420px;
    overflow: hidden;
    margin-bottom: 40px;

    &-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
    }

    .banner-text {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: white;
      text-align: center;
      
      h1 {
        font-size: 40px;
        letter-spacing: 2px;
        font-weight: 400;
        font-family: 'Noto Sans JP', sans-serif;
      }
        h3 {
          font-size: 20px; // 字体大小调整以适应移动端
        }
    }
  }

  .section {
    width: 50.5%;
    margin-left: auto;
    margin-right: auto;
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.6s ease, transform 0.6s ease;
    padding-top: 30px;  /* 添加顶部间距 */
    margin-top: -30px;
    margin-bottom: 14vh;
    font-family: 'Noto Sans JP', sans-serif;

    &.visible {
      opacity: 1;
      transform: translateY(0);
    }

    h2 {
      font-size: 40px;
      font-weight: 400;
      text-align: left;
      margin-top: 20px;
      margin-bottom: 30px;
      color: #414c64;
    }

    p {
      text-align: left;
      margin-bottom: 30px;
      font-size: 15px;
      color: #414c64;
      line-height: 28px;

      &.fade-in-visible {
        opacity: 1;
        transform: translateY(0);
      }

      strong {
        color: #293244;
        font-size: 18px;
        font-weight: 600;
        position: relative;
        line-height: 34px;
      }

      .fields {
        list-style: none;
        padding: 0;
        margin: 0;
      }

      .field {
        display: table;
        width: 100%;
        margin-bottom: 10px;

        .field-label, .field-content {
          display: table-cell;
          vertical-align: top;
          padding: 4px 0; /* 调整内边距以控制行高 */
        }

        .field-label {
          width: 10em; /* 固定宽度 */
          font-size: 15px;
          font-weight: 600;
        }

        .field-content {
          font-size: 15px;
        }
      }
    }

    /* 视觉差背景动画 */
    .vision::before {
      content: '';
      position: absolute;
      inset: 0;
      background: linear-gradient(45deg,rgb(0, 45, 14) 0%,rgb(0, 122, 35) 100%);
      z-index: -1;
      filter: url(#noiseFilter); /* 添加SVG噪声滤镜 */
    }

    /* 标题科技感光效 */
    .vision-header h2 {
      position: relative;
      display: inline-block;
      padding: 0 1em;
      color: rgba(11, 100, 23, 0.9);
      text-shadow: 0 0 3px rgba(108, 255, 152, 0.5);
    }

    .vision-header h2::after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 50%;
      width: 80%;
      height: 3px;
      background: linear-gradient(90deg, transparent,rgb(76, 240, 114), transparent);
      transform: translateX(-50%);
      animation: laserScan 2.5s infinite;
    }

    /* 内容区立体卡片效果 */
    .vision-content {
      perspective: 1000px;
    }

    .vision-content p,
    .vision-content1 p {
      position: relative;
      padding: 1.5em;
      margin: 1.5em 0;
      background:rgba(61, 147, 33, 0.06);
      border-radius: 8px;
      transform-style: preserve-3d;
      transition: transform 0.4s;
      text-align: left;
      white-space: pre-line; /* 比 pre-wrap 更宽松，保留换行但合并空格 */
      word-break: break-word; /* 防止长单词溢出 */
    }

    .vision-content p::before,
    .vision-content1 p::before {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 8px;
      border: 1px solid rgba(76, 240, 139, 0.3);
      transform: translateZ(-1px);
    }

    .vision-content p:hover,
    .vision-content1 p:hover {
      transform: translateY(-5px) rotateX(3deg);
    }

    /* 图片全息投影效果 */
    .img {
      border-radius: 8px;
      transition: transform 0.4s, filter 0.4s;
      filter: brightness(1.05) contrast(1.1);
    }

    /* 动态滤镜动画 */
    @keyframes laserScan {
      0% { transform: translateX(-150%); opacity: 0; }
      50% { opacity: 1; }
      100% { transform: translateX(50%); opacity: 0; }
    }

    /* 添加SVG噪声滤镜（不影响外部资源） */
    .vision svg {
      position: absolute;
      width: 0;
      height: 0;
    }

    .vision svg filter {
      filter: url(#noiseFilter);
    }

    /* 动态星际背景 */
    .develop::before {
      content: '';
      position: absolute;
      inset: 0;
      background: 
        radial-gradient(circle at 70% 20%, #2a0a4a 0%, #0d0630 60%),
        linear-gradient(135deg, #0d0630 30%, #2a1747 100%);
      z-index: -1;
      animation: starPulse 12s infinite alternate;
    }

    /* 标题数据矩阵效果 */
    .develop h2 {
      font-family: monospace;
      color:rgb(224, 255, 215);
      position: relative;
      padding: 0 2em;
    }

    .develop h2::after {
      content: '▼';
      position: absolute;
      right: 0;
      bottom: -0.5em;
      color:rgb(20, 81, 36);
      animation: matrixFall 1s infinite steps(4);
    }

    .company-table {
      width: 100%;
      margin: 0 auto;  /* 水平居中 */
    }

    .company-table tr {
      transition: all 0.3s;
      background: rgba(255,255,255,0.03);
      backdrop-filter: blur(0.5px);
    }

    .company-table tr:hover {
      transform: translateX(10px);
      background: linear-gradient(90deg, 
        transparent,
        rgba(138,43,226,0.1) 40%,
        transparent
      );
    }

    .company-table td {
      padding: 1.2em;
      position: relative;
      border: 1px solid transparent;
    }

    .company-table td:first-child {
      color:rgb(51, 96, 69);
      background:rgba(61, 147, 33, 0.06);
      font-weight: bold;
      border-right: 2px solid;
      border-image: linear-gradient(
        to bottom, 
        transparent 10%,
    rgb(169, 210, 172) 50%,
        transparent 90%
      ) 1;
    }

    .company-table tr:hover td:first-child::before {
      content: '';
      text-align: center;
      position: absolute;
      top: 0;
      height: 100%;
      width: 3px;
      animation: dataFlow 1.2s ease-out;
    }

    /* 图片量子跃迁效果 */
    .companyprofile .img {
      clip-path: polygon(5% 0, 95% 0, 100% 5%, 100% 95%, 95% 100%, 5% 100%, 0 95%, 0 5%);
      transition: all 0.4s;
      transform: scale(0.05); 
      filter: 
        drop-shadow(0 0 5pxrgb(144, 226, 43))
        contrast(1.1)
        brightness(1.05);
    }

    .companyprofile .img:hover {
      transform: 
        scale(1.03)
        rotate3d(1, 1, 0.5, 5deg);
      filter: 
        drop-shadow(0 0 5pxrgb(0, 30, 20))
        contrast(1.2)
        brightness(1.1);
      animation: quantumGlow 1.5s infinite;
    }

    /* 动态效果定义 */
    @keyframes starPulse {
      0% { opacity: 0.8; }
      100% { opacity: 1; }
    }

    @keyframes matrixFall {
      0% { opacity: 0; transform: translateY(-1em); }
      50% { opacity: 1; }
      100% { opacity: 0; transform: translateY(1em); }
    }

    @keyframes dataFlow {
      0% { opacity: 1; transform: translateY(-50%); }
      100% { opacity: 0; transform: translateY(150%); }
    }

    @keyframes quantumGlow {
      0%, 100% { filter: drop-shadow(0 0 5pxrgb(20, 30, 0)); }
      50% { filter: drop-shadow(0 0 5px #8a2be2); }
    }

  }

  .img {
    width: 80%;
  }

  @media (max-width: 768px) {

    .banner {
      height: 320px; // 高度调整以适应移动端

      .banner-text {
        h1 {
          font-size: 24px; // 字体大小调整以适应移动端
        }
      }
    }

    .section {
      width: 88%; // 宽度调整以适应移动端
      padding-top: 15px;  // 添加顶部间距
      margin-top: -15px;
      margin-bottom: 7vh; // 间距调整以适应移动端

      .first-child {
        width: 80px;
        padding-left: 15px;
        padding-right: 15px;
      }
      
      h2 {
        font-size: 24px; // 字体大小调整以适应移动端
        margin-top: 10px;
        margin-bottom: 15px;
      }

      p {
        margin-bottom: 15px;
        font-size: 14px; // 字体大小调整以适应移动端
        line-height: 20px; // 行高调整以适应移动端

        strong {
          font-size: 16px; // 字体大小调整以适应移动端
          line-height: 30px;
        }

        .field {
          .field-label {
            width: 8em; /* 调整宽度以适应移动端 */
            font-size: 14px;
          }

          .field-content {
            font-size: 14px;
          }
        }
      }
    }

    .img {
      width: 100%; // 宽度调整以适应移动端
      max-width: 100%;
      height: auto; // 确保图片自适应高度
    }
  }
}
</style>
